import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterUndefinedEntries',
  standalone: true,
  pure: false,
})
export class FilterUndefinedEntriesPipe implements PipeTransform {
  transform(entries: { key: any; value: any }[]): { key: any; value: any }[] {
    return entries.filter((entry) => entry.value !== undefined);
  }
}
